<template>
  <v-container grid-list-md class="mt-3 mb-3" style="max-width:2000px">
      <v-layout row wrap >
          <v-flex xs12 sm6 md4 v-for="collection in collections_lazy" :key="collection._id">

        

      <web-collection-card :collection='collection' :artefacts='artefacts'></web-collection-card>

          </v-flex>
      </v-layout>


        <web-speed-dial-add v-if="isMod||isContrib"></web-speed-dial-add>
      <div id="getNewCollections"></div>
  </v-container>
</template>

<script>
import Slick from "vue-slick";
export default {
  data() {
    return {
      end: 12,
      direction: "left",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,

      count: 0,
      transition: "slide-y-reverse-transition"
    };
  },
  computed: {
    collections_lazy() {
      return this.collections.slice(0, this.end);
    },
    collections() {
      return this.$store.getters.loadAllCollections;
    },
    artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isMod() {
      return this.$store.getters.isMod;
    },
    isContrib() {
      return this.$store.getters.isContrib;
    }
  },
  mounted: function() {
    document.title = "Collections";
    window.scrollTo(0, 0);
    if (this.collections.length == 0) this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadUsers");

    //  if(this.artefacts.length == 0)
    this.$store.dispatch("loadArtefacts");
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const elem = document.getElementById("getNewCollections");
      if (this.isScrolledIntoView(elem) && this.collections_lazy.length < this.collections.length) {
        this.end = this.end + 6;
      }
    },
    isScrolledIntoView(el) {
      var rect = el.getBoundingClientRect();
      var elemTop = rect.top;
      var elemBottom = rect.bottom;

      // Only completely visible elements return true:
      var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
      // Partially visible elements return true:
      //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
      return isVisible;
    },
    showContent(collection) {
      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      for (i = 0; i < this.artefacts.length; i++) {
        if (this.artefacts[i].collectionId.indexOf(collection.title) > -1) {
          return true;
        }
      }
      return false;
    },

    minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;
      else
        return (
          str
            .split(" ")
            .slice(0, spaces - 1)
            .join(" ") + "..."
        );
    },
    isLast(idart, coltitle) {
      var j,
        k = [];

      for (j = 0; j < this.artefacts.length; j++)
        if (this.artefacts[j].collectionId.indexOf(coltitle) > -1)
          k.push(this.artefacts[j]._id);

      if (k[k.length - 1] == idart) return true;
      else return false;
    }
  }
};
</script>

<style>
.greyback {
  background: #efefef;
}

.expansion-panel__container,
.expansion-panel__container--active {
  margin-top: 0px !important;
}
</style>

<style scoped>
.div1 {
  position: absolute;
  width: 67%;
  white-space: normal;
}

.group-title {
  color: white;
  font-size: 2.2em !important;
  top: 3%;
}

.group-subheading {
  position: absolute;

  font-size: 1.06em !important;
  top: 101%;
  left: 4%;
  color: white;
}

.collection-title {
  color: black;
  font-size: 1.5em !important;
  top: 3%;
}

.collection-subheading {
  position: absolute;

  font-size: 1.06em !important;
  top: 101%;
  left: 4%;
  color: black;
}

.headline {
  -webkit-text-stroke-width: 0.3px;
  -webkit-text-stroke-color: black;
}

.card-tile-1 {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/components/Common/Collections.vue